import styled from 'styled-components'

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 10px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  position: relative;
  overflow: hidden;
  min-width: 0;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`

export const IconContainer = styled.div<{ $color?: string }>`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${(props) => props.$color || 'rgba(0, 173, 230, 0.1)'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const MetricValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 3px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const MetricLabel = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 3px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const MetricHighlight = styled.span<{
  $type: 'success' | 'warning' | 'danger' | 'info'
  $textAlign?: 'left' | 'center' | 'right'
}>`
  font-size: 12px;
  font-weight: 600;
  text-align: ${(props) => props.$textAlign || 'left'};
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) =>
    props.$type === 'success'
      ? '#00B341'
      : props.$type === 'warning'
        ? '#FF9500'
        : props.$type === 'danger'
          ? '#FF3B30'
          : '#007AFF'};
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 5px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 3px;
  overflow: hidden;
  margin: 10px 0;
`

export const ProgressFill = styled.div<{
  $percentage: number
  $color?: string
}>`
  height: 100%;
  width: ${(props) => props.$percentage}%;
  background: ${(props) => props.$color || '#00ADE6'};
  border-radius: 3px;
  transition: width 0.3s ease;
`
